import * as React from 'react';

import './PartCardLoading.scss';

function PartCardLoading() {
  return (
    <div className="rp-part-card-loading">
      <div className="rp-part-card-loading--data">
        <span className="rp-part-card-loading--image " />
        <div className="data">
          <span className="loading-bar title" />

          <span className="loading-bar" />
          <span className="loading-bar" />

          <span className="loading-bar short" />

          <div className="prices">
            <span className="loading-bar short" />
            <span className="loading-bar short" />
          </div>
        </div>
      </div>
      <div className="buttons">
        <span className="loading-bar buttons" />
        <span className="loading-bar buttons" />
      </div>
    </div>
  );
}

export default PartCardLoading;
